import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { AuthSessionService } from './auth-session.service';
import { CognitoLogin } from './cognito-login';

/** Query parameter on links from Lakimonitori that asks a signed-out visitor to log in. */
export const FORCE_LOGIN_PARAMETER = 'forceLogin';

/**
 * Runs before the first navigation. A link carrying `?forceLogin` sends a signed-out visitor
 * straight to the Cognito login, which returns to the same page through its `returnTo` state.
 * The parameter is dropped from the address first, so neither the return from Cognito nor the
 * browser's back button starts another login.
 */
export function forceLoginOnEntry(): void {
  const view = inject(DOCUMENT).defaultView;
  if (!view) return;
  const url = new URL(view.location.href);
  if (!url.searchParams.has(FORCE_LOGIN_PARAMETER)) return;
  url.searchParams.delete(FORCE_LOGIN_PARAMETER);
  const target = `${url.pathname}${url.search}${url.hash}`;
  view.history.replaceState(view.history.state, '', target);

  const session = inject(AuthSessionService);
  const login = inject(CognitoLogin);
  void session.whenReady().then(() => {
    if (session.state().status === 'anonymous') login.start(target);
  });
}
